define('viewModels/dashboards/qualityAdminDashboard/EvaluatorActivityWidget',[
    'lib/lodash4',
    'lib/knockout',
    'viewModels/ViewModel',
    'util/errorCallbackFactory',
    'viewModels/privileged/qm/GroupSelectorView',
    'viewModels/privileged/qm/policies/editors/TeamSelectorView',
    'services/qualityManagementService'
], function (_, ko, ViewModel, errorCallbackFactory, GroupSelectorView, TeamSelectorView, qualityManagementService) {
    'use strict';

    var EVALUATOR_GRID_COLUMNS = [
        {
            label: 'qualityAdminDashboard.evaluators.evaluatorName',
            id: 'evaluatorName'
        },
        {
            label: 'qualityAdminDashboard.evaluators.evaluatorGroup',
            id: 'evaluatorGroup'
        },
        {
            label: 'qualityAdminDashboard.evaluators.evaluationProgress',
            id: 'evaluationProgress'
        },
        {
            label: 'qualityAdminDashboard.evaluators.calibrationsCompleted',
            id: 'calibrationsCompleted'
        }
    ];

    /**
     *  EvaluatorActivityWidget
     */
    var EvaluatorActivityWidget = ViewModel.extend(function (dateRangeObservable) {
        var self = this;

        self.activityDateRange = dateRangeObservable;
        self.nameFilter = ko.observable();
        self.group = ko.observable();
        self.groupSelector = self.subView(GroupSelectorView, self.group);
        self.team = ko.observable();
        self.teamSelector = self.subView(TeamSelectorView, self.team);
        self.isLoadingGrid = ko.observable(false);
        self.isLinkToggled = ko.observable(true);
        self.hasNameError = ko.observable(false);
        self.rows = ko.observableArray();

        self.gridOptions = ko.observable({
            pageCount: 1,
            pageNumber: 1,
            pageSize: 25
        });

        var buildEvaluatorGridRow = function (activity) {
            var evaluationPercentage = 0;
            if (activity.numEvaluationsAssigned > 0) {
                evaluationPercentage = activity.numEvaluationsCompleted / activity.numEvaluationsAssigned * 100;
            }

            return {
                evaluatorId: activity.evaluator.id,
                evaluatorName: {
                    displayName: activity.evaluator.name,
                    truncatedName: activity.evaluator.name.substring(0, 70),
                    isLinkToggled: self.isLinkToggled,
                    href: '#quality/admin/evaluators/' + activity.evaluator.id
                },
                progressLabel: 'qualityAdminDashboard.evaluators.evaluationRatio',
                numEvaluationsAssigned: activity.numEvaluationsAssigned,
                numEvaluationsCompleted: activity.numEvaluationsCompleted,
                numCalibrationsCompleted: activity.numCalibrationsCompleted,
                progressPercentage: evaluationPercentage
            };
        };

        self.refreshGrid = function (incomingOptions) {
            self.isLoadingGrid(true);
            var dates = self.activityDateRange()[0].split('/');
            var options = {};
            if (incomingOptions){
                if (incomingOptions.pageSize > self.gridOptions().pageSize){
                    options.pageNumber = 1;
                } else {
                    options.pageNumber = incomingOptions.pageNumber;
                }
                options.pageSize = incomingOptions.pageSize;
            }
            if (dates){
                options.startTime = dates[0];
                options.endTime = dates[1];
            }
            if (self.nameFilter()){
                options.pageNumber = 1;
                options.name = '*' + self.nameFilter() + '*';
            }
            if (self.group()){
                options.group = self.group().id;
            }
            if (self.team()){
                options.agentTeamId = self.team().id;
            }

            qualityManagementService.getRecentEvaluatorActivity(options)
                .then(function(queryResponse) {
                    self.gridOptions({
                        pageCount: queryResponse.pageCount,
                        pageNumber: queryResponse.pageNumber,
                        pageSize: !options.pageSize ? queryResponse.pageSize : options.pageSize
                    });
                    var responseRows = _.map(queryResponse.entities, buildEvaluatorGridRow);

                    self.rows(responseRows);
                    self.evaluatorGrid().rows(responseRows);
                    self.hasNameError(false);
                }).catch(function(error){
                    var httpStatus = error.type === 'http' ? error.details.status : undefined;
                    if(400 === httpStatus) {
                        if(error.details.response && error.details.response.code) {
                            if(error.details.response.code === 'qmevaluatoractivity.search.too.many.results') {
                                self.hasNameError(true);
                            }
                        }
                        self.rows([]);
                        self.evaluatorGrid().rows([]);
                    }
                }).finally(function(){
                    self.isLoadingGrid(false);
                });
        };

        self.subscribe(self.activityDateRange, function () {
            self.rows([]);
            self.evaluatorGrid().rows([]);
            self.gridOptions().pageNumber = 1;
            self.refreshGrid(self.gridOptions());
        });

        self.evaluatorGrid = ko.observable({
            columns: EVALUATOR_GRID_COLUMNS,
            rows: ko.observableArray([]),
            dataOptions: self.gridOptions,
            onDataOptionsChange: self.refreshGrid,
            loading: self.isLoadingGrid
        });

        self.refreshGrid(self.gridOptions());
    });

    return EvaluatorActivityWidget;
});

